/**
 * Better-Auth React client.
 *
 * Used by the five public auth routes (login, signup, forgot-password,
 * reset-password, verify-email) plus the in-product change-password form.
 *
 * `baseURL` resolves to the API's Better-Auth mount (`/v1/auth`). The BA
 * client validates this is an absolute URL on construction, so we always
 * build one from an explicit origin:
 *   - Dev: `VITE_API_ORIGIN` is unset, fall back to `window.location.origin`
 *     so requests go to `http://localhost:3001/v1/auth` and Vite's `/v1`
 *     proxy forwards to the API. The proxy rewrites the cookie domain to
 *     `localhost` so credentials stay first-party.
 *   - Prod: `VITE_API_ORIGIN=https://api.clickt.link`. The dashboard talks
 *     cross-subdomain to the API; the BA session cookie is set on
 *     `.clickt.link` (server-side, see apps/api/src/auth/better-auth.ts)
 *     so both subdomains see it.
 *
 * The tenancy query (`api.me()`) still lives on `/v1/app/me` and is unchanged
 * by this client. After signin/signup, callers should `qc.invalidateQueries`
 * for the `['me']` key so the membership lookup re-runs against the new
 * session.
 */

import { createAuthClient } from 'better-auth/react';

const apiOrigin =
  import.meta.env.VITE_API_ORIGIN ??
  (typeof window === 'undefined' ? 'http://localhost:3001' : window.location.origin);

export const authClient = createAuthClient({
  baseURL: `${apiOrigin}/v1/auth`,
});
